import { normalizeRecordStatus } from '../../shared/utils/recordStatusUtils';

/** Known path → storage bucket aliases */
export const PATH_TO_ENTITY = {
  '/facturation/fournisseurs': 'suppliers',
  '/facturation/suppliers': 'suppliers',
  '/suppliers': 'suppliers',
  '/api/facturation/fournisseurs': 'suppliers',
  '/facturation/clients': 'clients',
  '/api/facturation/clients': 'clients',
  '/ventes/clients': 'clients',
  '/facturation/facturiers': 'facturiers',
  '/facturation/products': 'products',
  '/api/products': 'products',
  '/products': 'products',
  '/facturation/categories': 'categories',
  '/categories': 'categories',
  '/services': 'services',
  '/archives': 'documents',
  '/facturation/archives': 'documents',
  '/documents': 'documents',
  '/hr/employees': 'employees',
  '/api/hr/employees': 'employees',
  '/employees': 'employees',
  '/hr/leaves': 'hr_leaves',
  '/hr/evaluations': 'hr_evaluations',
  '/hr/contracts': 'hr_contracts',
  '/training_sessions': 'training_sessions',
  '/recruitment_candidates': 'recruitment_candidates',
  '/payments': 'payments',
  '/finances': 'finances',
  '/partners': 'partners',
  '/pos/suppliers': 'suppliers',
  '/orders': 'orders',
  '/settings': 'settings',
  '/production/semi-finished': 'production_semi_finished',
  '/production/raw-materials': 'production_raw_materials',
  '/production/finished-products': 'production_finished_products',
};

/** Path suffixes that are not CRUD collections (stats, dashboards, etc.) */
export const NON_CRUD_SUFFIXES = [
  '/stats',
  '/recent',
  '/dashboard',
  '/today',
  '/upcoming',
  '/pending',
  '/summary',
  '/available',
  '/encours',
  '/auto-check',
  '/orders-for-conversion',
  '/reset',
  '/activity/recent',
  '/hierarchy',
  '/affectations',
];

/** Single-object config endpoints (not arrays) */
export const CONFIG_PATHS = new Set([
  '/settings',
  '/crm/config',
  '/comptabilite/config',
  '/fleet/config',
  '/planification/config',
  '/taches/config',
  '/qualite/config',
]);

/** Field normalization on create/update */
export const FIELD_ALIASES = {
  suppliers: { name: 'company_name' },
};

/** Explicit CRUD base paths (collection roots) — generated + curated */
export const CRUD_BASE_PATHS = [
  '/achats/appels-offres',
  '/achats/budget',
  '/achats/catalogue-fournisseurs',
  '/achats/controle-qualite',
  '/achats/demandes',
  '/achats/livre-des-achats',
  '/achats/negociations',
  '/achats/planification',
  '/achats/purchase-orders',
  '/achats/receptions',
  '/achats/retours',
  '/achats/strategie',
  '/api/articles/attributs',
  '/api/articles/classification-douaniere',
  '/api/articles/codes-barres',
  '/api/articles/cycle-vie',
  '/api/articles/equipment',
  '/api/articles/spare-parts',
  '/api/articles/variantes',
  '/api/articles/changelog',
  '/api/articles/cost-methods',
  '/api/articles/price-lists',
  '/api/approbations/workflows',
  '/api/approbations/requests',
  '/api/approbations/templates',
  '/api/employee-portal/documents',
  '/api/employee-portal/service-requests',
  '/api/employee-portal/announcements',
  '/api/inventaire/reservations',
  '/api/achats/comparatif-offres',
  '/api/contracts/approvals',
  '/api/contracts/claims',
  '/api/contracts/negotiations',
  '/api/contracts/obligations',
  '/api/maintenance/contracts',
  '/api/maintenance/emergency',
  '/api/maintenance/equipment',
  '/api/maintenance/preventive',
  '/api/maintenance/teams',
  '/api/maintenance/technicians',
  '/api/maintenance/tickets',
  '/api/maintenance/workorders',
  '/api/management/departments',
  '/api/projects/alerts',
  '/api/projects/changes',
  '/api/projects/deliverables',
  '/api/projects/milestones',
  '/api/projects/portfolio',
  '/api/projects/projects',
  '/api/projects/resources',
  '/api/projects/risks',
  '/api/projects/tasks',
  '/api/projects/time-logs',
  '/articles/marques-fabricants',
  '/budget/allocations',
  '/budget/budget-control',
  '/budget/cape',
  '/budget/cash-flow',
  '/budget/consolidation',
  '/budget/cost-centers',
  '/budget/engagements',
  '/budget/forecasts',
  '/budget/pluriannuelle',
  '/budget/revisions',
  '/budget/variance-monitoring',
  '/budget/workflow',
  '/categories',
  '/commercial/strategies',
  '/commercial/territories',
  '/comptabilite/documents',
  '/comptabilite/entries',
  '/comptabilite/accounts',
  '/comptabilite/balance',
  '/comptabilite/journal',
  '/comptabilite/grand-livre',
  '/comptabilite/bilan',
  '/comptabilite/resultat',
  '/comptabilite/flux',
  '/comptabilite/assets',
  '/comptabilite/annexes',
  '/comptabilite/rapports',
  '/comptabilite/comparatifs',
  '/comptabilite/cloture',
  '/comptabilite/auxiliaries',
  '/comptabilite/tax-declarations',
  '/comptabilite/liasse-fiscale',
  '/comptabilite/additional-taxes',
  '/banking/accounts',
  '/banking/statements',
  '/banking/reconciliation',
  '/banking/transfers',
  '/banking/checks',
  '/banking/payment-orders',
  '/treasury/journal',
  '/treasury/main',
  '/treasury/monthly',
  '/treasury/vouchers',
  '/treasury/bons',
  '/treasury/transfers',
  '/treasury/closure',
  '/salaires/journal-paies',
  '/salaires/primes-indemnites',
  '/salaires/avances-prets',
  '/salaires/incidents',
  '/salaires/missions',
  '/salaires/heures-sup',
  '/salaires/declarations-sociales',
  '/contracts/amendments',
  '/contracts/clients',
  '/contracts/guarantees',
  '/contracts/renewals',
  '/contracts/suppliers',
  '/contracts/templates',
  '/crm/campaigns',
  '/crm/contacts',
  '/crm/forecasting',
  '/crm/interactions',
  '/crm/leads',
  '/crm/opportunities',
  '/crm/sales-agents',
  '/crm/sales-goals',
  '/crm/segmentation',
  '/crm/support-tickets',
  '/crm/timeline',
  '/distribution/collection-points',
  '/distribution/complaints',
  '/distribution/daily-planning',
  '/distribution/delivery-teams',
  '/distribution/order-preparation',
  '/distribution/planning',
  '/distribution/routes',
  '/distribution/shipments',
  '/distribution/vehicle-capacities',
  '/distribution/zone-assignments',
  '/distribution/zones',
  '/documents',
  '/facturation/clients',
  '/facturation/conditions-paiement',
  '/facturation/facturation-electronique',
  '/facturation/factures-recurrentes',
  '/facturation/facturiers',
  '/facturation/fournisseurs',
  '/facturation/impayes-creances',
  '/facturation/modeles-mentions',
  '/facturation/numerotation',
  '/facturation/products',
  '/facturation/relances',
  '/facturation/suppliers',
  '/fleet/drivers',
  '/fleet/fuel',
  '/fleet/gps-tracking',
  '/fleet/inspections',
  '/fleet/insurance',
  '/fleet/maintenance',
  '/fleet/reservations',
  '/fleet/tires',
  '/fleet/vehicles',
  '/fleet/violations',
  '/gestion-situation/cartographie',
  '/gestion-situation/chronologie-events',
  '/gestion-situation/communication-crise',
  '/gestion-situation/crises',
  '/gestion-situation/documents-crise',
  '/gestion-situation/equipes',
  '/gestion-situation/incidents',
  '/gestion-situation/main-courante',
  '/gestion-situation/plans-intervention',
  '/gestion-situation/resources',
  '/gestion-situation/suivi-victimes',
  '/hr/accidents',
  '/hr/contracts',
  '/hr/departures',
  '/hr/employees',
  '/hr/evaluations',
  '/hr/leaves',
  '/hr/sanctions',
  '/recruitment_candidates',
  '/training_sessions',
  '/inventaire/warehouses',
  '/inventory/adjustments',
  '/inventory/locations',
  '/inventory/lots',
  '/inventory/movements',
  '/inventory/physical-inventory',
  '/inventory/pickings',
  '/inventory/replenishments',
  '/inventory/stock-alerts',
  '/inventory/transfers',
  '/inventory/warehouses',
  '/livraison/delivery-proofs',
  '/livraison/delivery-statuses',
  '/livraison/ongoing',
  '/livraison/real-time-tracking',
  '/livraison/refused-deliveries',
  '/livraison/route-sheets',
  '/livraison/vehicle-loading',
  '/logistics/carriers',
  '/logistics/codes',
  '/logistics/consolidation',
  '/logistics/deliveries',
  '/logistics/incidents-delays',
  '/logistics/loading-dispatch',
  '/logistics/route-optimization',
  '/logistics/transport-costs',
  '/logistics/transport-manifests',
  '/management/departments',
  '/marketing/budget',
  '/marketing/campaigns',
  '/marketing/channel-performance',
  '/marketing/content-media',
  '/marketing/events',
  '/marketing/partnerships',
  '/marketing/roi',
  '/marketing/segments',
  '/marketing/social-media',
  '/parc-auto/vehicles',
  '/planification/calendrier',
  '/planification/charge',
  '/planification/contraintes',
  '/planification/equipes',
  '/planification/rappels',
  '/planification/rendez-vous',
  '/planification/ressources',
  '/planification/utilisation',
  '/pointage/affectations-equipes',
  '/pointage/conges',
  '/pointage/feries',
  '/pointage/horaires',
  '/pointage/justificatifs',
  '/pointage/profils-horaires',
  '/pointage/recuperations',
  '/pointage/zones-travail',
  '/products',
  '/relation-fournisseur/appels-offres',
  '/relation-fournisseur/candidats',
  '/relation-fournisseur/chronologie',
  '/relation-fournisseur/conformite-certifications',
  '/relation-fournisseur/contacts-comptes',
  '/relation-fournisseur/contrats-accords-cadres',
  '/relation-fournisseur/demandes-cotation',
  '/relation-fournisseur/evaluation-performance',
  '/relation-fournisseur/historique-commandes',
  '/relation-fournisseur/interactions',
  '/relation-fournisseur/negociations',
  '/relation-fournisseur/reclamations-litiges',
  '/relation-fournisseur/risques',
  '/relation-fournisseur/segmentation',
  '/salaires/retenues-diverses',
  '/salaires/virements-bancaires',
  '/sales/commissions',
  '/sales/forecasts',
  '/sales/objectives',
  '/ventes/pipeline',
  '/sales/team',
  '/service-client/chat',
  '/service-client/escalation',
  '/service-client/history',
  '/service-client/interventions',
  '/service-client/knowledge-base',
  '/service-client/reclamations',
  '/service-client/routing',
  '/service-client/satisfaction',
  '/service-client/scripts',
  '/service-client/sla',
  '/service-client/support-team',
  '/service-client/tickets',
  '/services',
  '/suppliers',
  '/taches/backlog',
  '/taches/calendar',
  '/taches/dependencies',
  '/taches/gantt',
  '/taches/kanban',
  '/taches/milestones',
  '/taches/projects',
  '/taches/reminders',
  '/taches/sprints',
  '/taches/tasks',
  '/taches/team',
  '/taches/timesheet',
  '/timetracking/absences',
  '/timetracking/lateness',
  '/timetracking/overtime',
  '/timetracking/planning',
  '/tresorerie/bank-relations',
  '/tresorerie/financing',
  '/tresorerie/fore',
  '/tresorerie/investments',
  '/tresorerie/liquidity',
  '/ventes/livraisons',
  '/ventes/livre-des-ventes',
  '/ventes/pri',
  '/ventes/sales-orders',
  '/ventes/sales-returns',
  '/finances',
  '/payments',
  '/partners',
  '/employees',
];

/**
 * Convert API base path to storage entity bucket name.
 */
export function pathToEntity(basePath) {
  if (PATH_TO_ENTITY[basePath]) return PATH_TO_ENTITY[basePath];
  return basePath.replace(/^\//, '').replace(/\//g, '_').replace(/-/g, '_');
}

/**
 * Check if path is a non-CRUD endpoint (stats, dashboard, etc.)
 */
export function isNonCrudPath(path) {
  if (CONFIG_PATHS.has(path)) return true;
  return NON_CRUD_SUFFIXES.some((s) => path.endsWith(s) || path.includes(s));
}

/**
 * Resolve a request path to CRUD routing info.
 * @returns {{ basePath: string, entity: string, id: string|null } | null}
 */
export function resolveCrudPath(path) {
  const normalized = path.replace(/\/+$/, '') || '/';

  if (CONFIG_PATHS.has(normalized)) {
    return { basePath: normalized, entity: pathToEntity(normalized), id: null, isConfig: true };
  }

  if (isNonCrudPath(normalized)) return null;

  // Exact base path match
  if (CRUD_BASE_PATHS.includes(normalized)) {
    return { basePath: normalized, entity: pathToEntity(normalized), id: null };
  }

  // Path with ID: /module/collection/:id
  for (const base of CRUD_BASE_PATHS) {
    if (normalized.startsWith(`${base}/`)) {
      const rest = normalized.slice(base.length + 1);
      if (rest && !rest.includes('/')) {
        return { basePath: base, entity: pathToEntity(base), id: rest };
      }
    }
  }

  // Dynamic two+ segment fallback for unlisted paths
  const dynamic = normalized.match(/^(\/[a-z0-9-]+(?:\/[a-z0-9-]+)+)(?:\/([^/]+))?$/i);
  if (dynamic) {
    const basePath = dynamic[1];
    const id = dynamic[2] || null;
    if (isNonCrudPath(basePath)) return null;
    if (CONFIG_PATHS.has(basePath)) return null;
    return { basePath, entity: pathToEntity(basePath), id };
  }

  // Top-level single segment: /products, /categories
  const top = normalized.match(/^(\/[a-z0-9-]+)(?:\/([^/]+))?$/i);
  if (top) {
    const basePath = top[1];
    const id = top[2] || null;
    if (PATH_TO_ENTITY[basePath] || ['products', 'categories', 'services', 'suppliers', 'documents', 'employees', 'payments', 'finances', 'partners', 'orders'].includes(pathToEntity(basePath))) {
      return { basePath, entity: pathToEntity(basePath), id };
    }
  }

  return null;
}

/** All unique seed entity bucket names */
export function getAllSeedEntities() {
  const set = new Set([
    'clients',
    'products',
    'documents',
    'employees',
    'suppliers',
    'finances',
    'payments',
    'categories',
    'partners',
    'facturiers',
    'services',
    'orders',
    'settings',
  ]);
  for (const base of CRUD_BASE_PATHS) {
    set.add(pathToEntity(base));
  }
  return [...set].sort();
}

/** Delivery/logistics buckets keep domain-specific status codes (planifie, en_transit, …). */
function shouldNormalizeRecordStatus(entity) {
  const e = String(entity || '');
  if (e.startsWith('livraison_')) return false;
  if (e === 'distribution_planning' || e === 'distribution_planning_') return false;
  return true;
}

export function normalizeRecord(entity, record) {
  if (!record || typeof record !== 'object') return record;
  const out = { ...record };
  if (out.status != null && shouldNormalizeRecordStatus(entity)) {
    out.status = normalizeRecordStatus(out.status);
  }
  const aliases = FIELD_ALIASES[entity];
  if (!aliases) return out;
  for (const [from, to] of Object.entries(aliases)) {
    if (out[from] != null && out[to] == null) {
      out[to] = out[from];
      delete out[from];
    }
  }
  return out;
}

export default {
  PATH_TO_ENTITY,
  CRUD_BASE_PATHS,
  pathToEntity,
  resolveCrudPath,
  getAllSeedEntities,
  normalizeRecord,
  isNonCrudPath,
  CONFIG_PATHS,
};
